import React, { useRef } from 'react'
import './Join.css'
import emailjs from "@emailjs/browser";

const Join = () => {
  const form = useRef();

    const handleJoin = (e)=> {
        e.preventDefault()
        emailjs.sendForm(
            'service_e4alkpt',
            'template_j66l6aq',
            form.current,
            '5oSA-dSsmaPIXHzWA'
        )
        .then((result)=>{
            console.log('done')
        },
        (error)=>{
            console.log(error)
        }
        )
    }
  return (
   <div className="Join" id='join-us'>
    <div className="left-j">
        <hr />
        <div><span className='stroke-text'>¿Preparado para</span><span>el siguiente nivel</span></div>
        <div><span>de tu cuerpo</span><span className='stroke-text'>con nosotros?</span></div>
    </div>
    <div className="right-j">
        <form className="email-container" ref={form} onSubmit={handleJoin}>
            <input type="email" name='user_email' placeholder='Introduce tu email'/>
            <button type='submit' className="btn btn-j">Únete ahora</button>
        </form>
    </div>
   </div>
  )
}

export default Join